import React from 'react';
import Editor from './Loadable';
import { FieldRenderProps } from 'react-final-form';

export default ((props: FieldRenderProps<any, HTMLInputElement> & any) => {
  const { input, meta, ...rest } = props;
  return <Editor {...input} {...rest} />;
}) as React.FC<FieldRenderProps<any, HTMLInputElement> & any>;
